import React from 'react'
import LoanSummary from "./LoanSummary"

export default function LoanAgreement({ loanAgreementData }) {
  return loanAgreementData && (
    <div id="step3" className="loan-signing-container">
      <div className="app-card">
        <h2 data-ui-test="title-1" className="title agreement-title">
          Please review and sign your Loan Agreement
        </h2>
        <div>
          <p className="loan-agreement-text">
            Please take a moment to review the <a>Loan Agreement</a> and <a>Terms of your Loan </a>carefully.
            You will be required to electronically sign and date it. You will also
            electronically sign and date the disbursement and payment choice authorizations.
          </p>
          <LoanSummary loanAgreementData={loanAgreementData} classes="my-3" />
          <div>
            <form className="main-form-wrap ">
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I acknowledge that I have read and agree to the <a>Consent to Electronic
                      Communications</a> (the “CONSENT“), and I agree to receive electronic communications from
                    Development. <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I affirm that I am not a <a>member of the military</a>, nor am I a dependent
                    or spouse of any member of the military.
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I agree to receive funds according to the terms in the <a>Disbursement
                      Authorization</a>
                    (the &quot;AUTHORIZATION&quot;). <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I authorize electronic fund transfer payments from My Bank Account, via the
                    <a>Payment Choice Authorization.</a>
                    (Please note, you are not required to authorize this Payment Choice Authorization option in
                    order to be approved for a Loan).
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I consent to the <a>Dispute Resolution and Arbitration Procedure</a>.
                    <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I expressly <a>Consent to be Contacted by {loanAgreementData.borrower}</a>, its agents,
                    affiliates or anyone calling on its behalf at {loanAgreementData.phone}, by use of text
                    messages and auto-dialed and/or pre-recorded calls, for any and all purposes arising out of or
                    relating to my application, Loan and/or account or for any marketing or advertising
                    purposes. I understand that my consent is not required to obtain a Loan and that I may opt-out at
                    any time.
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I agree to the promotional terms available&nbsp;
                    <a>HERE</a>&nbsp;,
                    and acknowledge that if I do not abide by the promotional terms, the promotion will be
                    automatically
                    revoked and I will remain obligated under the terms of my loan agreement. <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
              <div className="checkbox-input columns mt-4 pl-4">
                <span className="checkbox pt-1">
                  <input name="is_electronic_consent" id="is_electronic_consent" type="checkbox" disabled />
                </span>
                <div className="label ml-3">
                  <label className="align-top" id="checkbox-label" htmlFor="is_electronic_consent">
                    By checking this box, I agree that I have opened and read the
                    <span className="loan-upper">Loan Agreement</span>, the CONSENT and the AUTHORIZATION
                    and understand all of the terms of this Loan. <a>Click here</a> to review the terms of your
                    <span className="loan-upper">Loan Agreement</span>, the CONSENT and the AUTHORIZATION.
                    <span className="has-text-danger">*</span>
                  </label>
                </div>
              </div>
            </form>
            <div className="notice-name--wrapper">
              <div className="notice checkbox-text">
                By typing your name and clicking the &quot;Sign Loan Agreement&quot; button below, you are
                electronically signing the <span className="loan-upper">Loan Agreement</span>, the
                CONSENT and the AUTHORIZATION and agreeing to all of the terms of this Loan. You
                are also acknowledging that you have read the entire&nbsp;
                <span className="loan-upper">Loan Agreement</span>, CONSENT and AUTHORIZATION and
                have the ability to download or print a fully completed copy of this&nbsp;
                Loan Agreement for your records. <a> Click here </a> to review the terms of your
                <span className="loan-upper">Loan Agreement</span>, the CONSENT and the AUTHORIZATION.
              </div>
            </div>
            <div className="notice-input--wrapper field text-input mt-6">
              <div className="field text-input mb-0">
                <div className="label">
                  <label className="has-text-primary is-size-6 mb-2 mt-4" id="field--ssp-name-on-card-id-label" htmlFor="field--ssp-name-on-card-id">
                    Please type your name exactly as it appears on your application. <span className="has-text-danger"> *</span>
                  </label>
                </div>
                <div className="field text-input">
                  <div className="control null">
                    <input name="full_name" className="input undefined undefined" value="" disabled />
                  </div>
                </div>
              </div>
            </div>
            <p className="is-size-6 has-text-weight-bold">{loanAgreementData?.borrower}</p>
            {loanAgreementData.risk_based_pricing_notice && (
              <p className="notice">
                Click <a>here</a> to view your Risk-Based Pricing Notice.
              </p>
            )}
            <div className="step-actions my-5 has-text-centered">
              <button type="submit" className="button is-primary py-3" disabled>
                <span className="mx-3"> Sign Loan Agreement </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
